import {
  ContentBlock,
  Box,
  Heading,
  IconArrow,
  Columns,
  Column,
} from 'braid-design-system';
import React from 'react';

import { ButtonLink } from 'src/components';

const trackingProps = {
  elementText: 'return product clicked',
  elementDesign: 'link',
  elementAction: 'directs user to to product overview page',
  actionOrigin: 'bottom button company profile page',
};

export const WhatsNewBanner = () => (
  <ContentBlock>
    <Box
      paddingX={{ mobile: 'large', tablet: 'xxlarge' }}
      paddingTop={{ mobile: 'xxlarge', tablet: 'xxlarge' }}
      paddingBottom={{ mobile: 'xlarge', tablet: 'xxlarge' }}
      background="customDark"
      borderRadius={{ mobile: 'none', tablet: 'large' }}
      position="relative"
      style={{ marginTop: '60px', backgroundColor: '#080559' }}
    >
      <Columns space="gutter" alignY="center" collapseBelow="tablet">
        <Column>
          <Heading level="2" align={{ mobile: 'center', tablet: 'left' }}>
            <span
              style={{ fontSize: '36px', color: '#fff', fontWeight: '500' }}
            >
              See what&apos;s new
            </span>
          </Heading>
        </Column>
        <Column width="content">
          <ButtonLink
            icon={<IconArrow direction="left" />}
            href="/products"
            style={{ position: 'relative', cursor: 'pointer' }}
            tracking="content_element_pressed"
            trackingProps={trackingProps}
          >
            Return to product home
          </ButtonLink>
        </Column>
      </Columns>
    </Box>
  </ContentBlock>
);
